import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

export enum LogLevel {
  Debug = 0,
  Info = 1,
  Warn = 2,
  Error = 3
}

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  private level: LogLevel = environment.production ? LogLevel.Info : LogLevel.Debug;

  debug(message: string, ...data: unknown[]): void {
    this.logWith(LogLevel.Debug, message, data);
  }

  info(message: string, ...data: unknown[]): void {
    this.logWith(LogLevel.Info, message, data);
  }

  warn(message: string, ...data: unknown[]): void {
    this.logWith(LogLevel.Warn, message, data);
  }

  error(message: string, ...data: unknown[]): void {
    this.logWith(LogLevel.Error, message, data);
  }

  private logWith(level: LogLevel, message: string, data: unknown[]): void {
    if (level >= this.level) {
      const timestamp = new Date().toISOString();
      const prefix = `[${timestamp}]`;
      
      switch (level) {
        case LogLevel.Debug:
          if (data.length) {
            console.debug(prefix, message, ...data);
          } else {
            console.debug(prefix, message);
          }
          break;
        case LogLevel.Info:
          if (data.length) {
            console.info(prefix, message, ...data);
          } else {
            console.info(prefix, message);
          }
          break;
        case LogLevel.Warn:
          if (data.length) {
            console.warn(prefix, message, ...data);
          } else {
            console.warn(prefix, message);
          }
          break;
        case LogLevel.Error:
          if (data.length) {
            console.error(prefix, message, ...data);
          } else {
            console.error(prefix, message);
          }
          break;
      }
    }
  }
}